<lib-modal-layout [title]="'Bind Request'" [subtitle]="data.subTitle">
  <p class="text-center py-3">Please confirm the following required documents to proceed with your Bind Request.</p>
  <form [formGroup]="form" class="text-left">
    <h4 class="mt-4">Signed Application</h4>
    <p class="py-3">A signed application is required to submit a bind request. Upload file now or confirm existing files are already uploaded.</p>
    <lib-form-file-attachment
      formControlName="application"
    ></lib-form-file-attachment>
    @if (viewSubmissionStore.applicationDocuments().length > 0) {
      <div class="text-left mt-4">
        <p >The following application files have already been uploaded to the Documents section.</p>
        @for (document of viewSubmissionStore.applicationDocuments(); track document) {
          <p class="font-semibold">
            {{ document.name }}
          </p>
        }
      </div>
    }

    <h4 class="mt-[35px]">Loss Runs</h4>
    <p class="py-3">Loss runs documents are required to submit a bind request. Upload file now or confirm existing files are already uploaded.</p>
    <lib-form-file-attachment
      formControlName="lossRuns"
    ></lib-form-file-attachment>
    @if (viewSubmissionStore.lossRunDocuments().length > 0) {
      <div class="text-left mt-4">
        <p>The following application files have already been uploaded to the Documents section.</p>
        @for (document of viewSubmissionStore.lossRunDocuments(); track document) {
          <p class="font-semibold">
            {{ document.name }}
          </p>
        }
      </div>
    }
    <lib-custom-date-picker
      style="max-width: 100%;width: 500px;display: flex; justify-self: center;padding-top: 20px;"
      label="Proposed Policy Effective Date"
      formControlName="proposedEffectiveDate"
      [minDate]="minEffectiveDate"
      [maxDate]="maxEffectiveDate">
    </lib-custom-date-picker>

    @if (!data.retailAgentId) {
      <h4 class="mt-[35px]">Agency/Producer Information</h4>
      <p class="py-3">Please provide the following agency and producer information.</p>

      <div class="w-full flex gap-[35px]">
        <lib-form-text class="w-1/2" label="Agency Name" formControlName="agencyName" maxlength="150"></lib-form-text>
        <lib-form-text class="w-1/2" label="Producer Name" formControlName="producerName" maxlength="150"></lib-form-text>
      </div>

      <div class="w-full flex gap-[35px]">
        <lib-form-text class="w-1/2" label="Primary Agency Address" formControlName="agencyAddress1" maxlength="50"></lib-form-text>
        <lib-form-text class="w-1/2" label="Suite" formControlName="agencyAddress2" maxlength="50"></lib-form-text>
      </div>

      <div class="w-full flex gap-[35px]">
        <lib-form-text class="w-1/2" label="City" formControlName="agencyCity" maxlength="64"></lib-form-text>
        <div class="flex w-1/2 gap-[35px]">
          <lib-form-dropdown class="w-1/2" label="State" [options]="lookupStore.states()!" [placeholder]="'Select State'" formControlName="agencyStateCode"></lib-form-dropdown>
          <lib-form-text class="w-1/2" label="Zip Code" formControlName="agencyZipCode" mask="99999" maxlength="10"></lib-form-text>
        </div>
      </div>
    }

    <p class="text-center py-5">A program administrator will be notified of your Bind Request and will follow up within 2 business days.</p>
    <div class="mt-[30px] text-center">
      <lib-button 
        [cssType]="'btn-primary'" 
        [text]="'Submit Bind Request'" 
        [icon]="'rightarrow'"  
        [size]="'large'"  
        (click)="submit()">
      </lib-button>
    </div>
  </form>

</lib-modal-layout>
